import { createContext, useContext } from 'react';

export const DialogContext = createContext(null);

export function useDialog() {
  const dialog = useContext(DialogContext);
  if (!dialog) throw new Error('useDialog requires DialogProvider');
  return dialog;
}
